import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import carfaxLogo from '../../../components/assets/carfax-logo.svg';

const VehicleFooterInfo = () => {
  const theme = useTheme();

  const { t } = useTranslation('carDetails');

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '2rem',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'center',
        alignItems: 'stretch',
      }}
    >
      {/* Set Alert Section */}
      <Box
        sx={{
          backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#fff',
          borderRadius: '8px',
          padding: '2rem 3rem',
          textAlign: 'center',
          border: `2px solid ${theme.palette.primary.main}`,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '1.25rem',
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: `${16 / 16}rem`,
          }}
        >
          {t('Get Alerts on similar vehicles')}
        </Typography>
        <Button
          variant="outlined"
          startIcon={<NotificationsNoneIcon />}
          sx={{
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            textTransform: 'none',
            fontSize: `${16 / 16}rem`,
            fontWeight: 500,
            borderRadius: '8px',
            paddingTop: '0.625rem',
            paddingBottom: '0.625rem',
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
            borderWidth: '2px',
            transition: 'all 0.2s ease',
            '&:hover': {
              borderWidth: '2px',
              borderColor: theme.palette.primary.main,
              backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(25, 118, 210, 0.04)',
            },
          }}
        >
          {t('Set Alert')}
        </Button>
      </Box>

      {/* Carfax Section */}
      <Box
        sx={{
          backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#fafafa',
          borderRadius: '8px',
          padding: '2rem 3rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '1rem',
          flex: 1,
        }}
      >
        <Box
          component="img"
          src={carfaxLogo}
          alt={t("Carfax Logo")}
          sx={{
            height: '2.5rem',
            objectFit: 'contain',
          }}
        />
        <Typography
          component="a"
          href="#"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: theme.palette.text.primary,
            fontSize: `${16 / 16}rem`,
            textDecoration: 'underline',
            fontWeight: 500,
            transition: 'all 0.2s ease',
            '&:hover': {
              color: theme.palette.primary.main,
            },
          }}
        >
          {t('View Report')}
        </Typography>
      </Box>
    </Box>
  );
};

export default VehicleFooterInfo;